import { Component, type ErrorInfo, type ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  failed: boolean;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Beautify Ourselves failed to render", error, errorInfo);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="content-page">
          <div className="empty-state">
            <p className="eyebrow">Something went wrong</p>
            <h1>We couldn’t display this page.</h1>
            <p>Please try loading it again.</p>
            <a className="button" href={window.location.href}>
              Reload page
            </a>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
